import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { stringToInline } from '@App/helpers/string-to-inline'
import { StoresContext } from '@App/contexts'

interface TabsAlertMessageProps {
    currentTab: string
}

const TabsAlertMessage = observer((props: TabsAlertMessageProps) => {
    const { popupStore } = useContext(StoresContext)
    const tabsAlertData = popupStore.tabsAlertData
    const itIsCurrentTab = tabsAlertData && stringToInline(tabsAlertData.tabName) === stringToInline(props.currentTab)

    if (!tabsAlertData || !tabsAlertData.message || !itIsCurrentTab) {
        return null
    }

    return (
        <div className={`tabs-alert-message-component ${tabsAlertData.isError ? 'error' : ''}`}>
            <p>{tabsAlertData.message}</p>
        </div>
    )
})

export default TabsAlertMessage
